import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faCircleXmark } from "@fortawesome/free-solid-svg-icons";

import "./ValidateResultIcon.css";

interface ValidateResultIconProps {
    isValid: boolean | undefined;
}

export default function ValidateResultIcon(props: ValidateResultIconProps) {

    const { isValid } = props;

    return (
        <>
            {isValid === undefined ? "" : <FontAwesomeIcon className={isValid ? "green-check" : "red-cross"} icon={isValid ? faCircleCheck : faCircleXmark}/>}
        </>
    );
}